export default "/images/995bfa24c4d52ca385145ba91d5ab565.avif";